module.exports = ".cell-liner {\n  position: relative; }\n\n:host(th) .cell-liner {\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis; }\n\n.boundary-left, .boundary-right {\n  position: absolute;\n  top: 0px;\n  bottom: 0px;\n  width: 1px; }\n\n.boundary-left {\n  left: 0px; }\n\n.boundary-right {\n  right: 0px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/controls/table-cell/table-cell.component.scss
// module id = ./src/app/controls/table-cell/table-cell.component.scss
// module chunks = main